import { createIf } from "typescript";

(function ($) {
    $(document).ready(function () {


        $('body').on('keyup', function(e) {
            // console.log(jQuery(':focus'));
            // console.log(e.target);
            // console.log(e);
            if (e.which == 9) {     
                if(!e.shiftKey){
    
                    jQuery('.focus_with_tab').removeClass('focus_with_tab');
                    if( jQuery(':focus').length>0) {
                        jQuery(':focus').addClass('focus_with_tab');
                    }
                }
          
            }
    });
    



        if(jQuery('.wpcf7').length > 0) {
            jQuery('.wpcf7-form-control-wrap .wpcf7-form-control').focus(function(){
                jQuery(this).parents('li').find("label").addClass('focus');
            })
            jQuery('.wpcf7-form-control-wrap .wpcf7-form-control').blur(function(){
                if (!jQuery(this).val()) {
                    jQuery(this).parents('li').find("label").removeClass('focus');
                }
            })
            jQuery('.wpcf7-form-control-wrap select.wpcf7-form-control').change(function(){
                if (!jQuery(this).val()) {
                    jQuery(this).parents('li').find("label").removeClass('focus');
                }
                else{
                    jQuery(this).parents('li').find("label").addClass('focus');
                }
            })
        }



        $('.page-template-financing-tco .tcu_page').on('input','.field h2 input',function(){
            $(this).css('width',($(this).val().length+1)+'ch');

        });
            $('.page-template-financing-tco .tcu_page').on('change','.funding_amount input',function(){
            var v=Number($('.funding_amount input').val().replace(/,/g, ''));
            $('h2.funding_amount').html('<input type="text" value="'+v.toLocaleString() + '" /> &#8362;');
            var max_funding_amount=$('.max_funding_amount').html()?$('.max_funding_amount').html():$('.max_funding_amount'+'_'+$('input[name=brandname]:checked').val().toUpperCase()).html()

            var price=Number($('.tcu_mm_models').find('option:selected').attr('data-price'));
            if(price< Number(max_funding_amount))
            var price_or_max_funding=price;
            else var price_or_max_funding=max_funding_amount;
            onFundingAmountChange(v,price_or_max_funding); 

            $('.funding_amount input').focus();
        });
        $('.page-template-financing-tco .tcu_page').on('change','.first_payment input',function(){
            var v=Number($('.first_payment input').val().replace(/,/g, ''));
            $('h2.first_payment').html('<input type="text" value="'+v.toLocaleString() + '" /> &#8362;');
            if(v<'20000')
                v=20000;
            else if(v>$('.tcu_mm_models').find('option:selected').attr('data-price'))
                v=$('.tcu_mm_models').find('option:selected').attr('data-price');
            onFirstPaymentChange(v,$('.tcu_mm_models').find('option:selected').attr('data-price')); 
            $('.tcu_page .slider-input.first_payment').jRange('setValue', v);
            $('.first_payment input').focus();
        });
        $('.page-template-financing-tco .tcu_page').on('change','.last_payment input',function(){
            var v=Number($('.last_payment input').val().replace(/,/g, ''));
            $('h2.last_payment').html('<input type="text" value="'+v.toLocaleString() + '" /> &#8362;');
            onLastPaymentChange(v,$('.tcu_mm_models').find('option:selected').attr('data-price')/2);
            v=v.toString();

            $('.tcu_page .slider-input.last_payment').jRange('setValue', v);
            $('.last_payment input').focus();


        });

        $('.faq .faq_item ').on('click','.question',function(){
            $(this).toggleClass('active');
        });

        $('.openForm').on('click',function(){

            var brand =$('.finance select.tcu_brands option:selected').attr('data-brand');
            var model=$('.finance select.tcu_models option:selected' ).attr('data-id');
            var iselectriccar=$('.finance select.tcu_models option:selected' ).attr('data-iselectriccar');
            var url = '/wp-admin/admin-ajax.php';
            if(window.location.href.indexOf('testonline') != -1){
                url = 'wp-admin/admin-ajax.php';
            }
            var rout = $('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .slider.round span:first-child').html();
            if($('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .switch input').is(":checked")){
                rout = $('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .slider.round span:last-child').html();
            }
            dataLayer.push({
                'Category': 'financing calculator', 
                'action': 'get quote', 
                'label': model+' | '+$('.finance select.tcu_mm_models option:selected').html()+' | '+rout, 
                'event': 'auto_event'
            });
            //console.log('datalayer',dataLayer)
            $.ajax({
                url: url, // AJAX handler
                type: 'POST',
                data:{
                    action:'get_crmmodelcode',
                    brand:  brand,
                    model: model,
                    iselectriccar: iselectriccar
                },
                
                success: function (res) {
                  res=JSON.parse(res);
                    $('.financeCalcFormBg #model').attr('data-crmcode',res);
                }
            });  

    

            
            $('.financeCalcFormBg #model').val($('select.tcu_models option:selected').val());
            //$('.financeCalcFormBg #model').attr('data-crmcode',$('select.tcu_models option:selected').attr('data-crmcode'));
+           $('.financeCalcFormBg #market_model').val($('select.tcu_mm_models option:selected').html());
            $('.financeCalcFormBg').show();
            $('.financeCalcFormBg .financeFormWrapper').show();
            $('.financeCalcFormBg .financeFormWrapper input[type=submit]').attr('disabled',false);
        });
        
        if($('.finance select.tcu_brands option:selected').length>0 && $('.finance select.tcu_brands option:selected').attr('data-brand')!='LUBINSKI'){

        updateModelsSelect();

    }
    
// var first_payment = $('.page-template-financing-tco .tcu_form').width();

        $('.page-template-financing-tco .tcu_page').on('change','.choose .switch input',function(){

                if(this.checked) {
                    $('.tcu_page .calculator_result .details p.baloon').css('display','none');
                    $('.tcu_page .calculator_result .details p.regular').css('display','block');
                    $('.funding_amount, .slider-input.funding_amount, .funding_amount + .tcu_title_center, .slider-input.funding_amount + .slider-container').css('display','none');
                    $('.fields .field:nth-of-type(1)').css('display','none');
                    $('.fields .field:nth-of-type(2)').css('display','block');
                
                    $('.first_payment, .slider-input.first_payment').css('display','inline-block');
                    $(' .first_payment + .tcu_title_center, .slider-input.first_payment + .slider-container').css('display','block');
                    $('.last_payment, .slider-input.last_payment').css('display','inline-block');
                    $(' .last_payment + .tcu_title_center, .slider-input.last_payment + .slider-container').css('display','block');
                    $('.result').css('height',$('.fields').height()-60);


                  }
                  else {
                    $('.fields .field:nth-of-type(1)').css('display','block');
                    $('.fields .field:nth-of-type(2)').css('display','none');
                    $('.first_payment, .first_payment + .tcu_title_center, .slider-input.first_payment, .slider-input.first_payment + .slider-container').hide();
                    $('.funding_amount, .funding_amount + .tcu_title_center, .slider-input.funding_amount, .slider-input.funding_amount + .slider-container').show();
                    $('.last_payment, .last_payment + .tcu_title_center, .slider-input.last_payment, .slider-input.last_payment + .slider-container').hide();
                    $('.tcu_page .calculator_result .details p.regular').css('display','none');
                    $('.tcu_page .calculator_result .details p.baloon').css('display','block');
                    $('.result').css('height',$('.fields').height()-60);

                  }
                  updateLastMax($('.tcu_mm_models').find('option:selected').attr('data-price'));

                  financeCalc();
        });


        $('body.page-template-financing-tco .tcu_page form.tcu_form .wrapper_lubinski_brands input[type="radio"]').on('click', function(e) {
            $('.select_wrapper.desktop > *').hide();
            $('.select_wrapper.desktop .mm_image2').css('display','inline-block');
            $('.finance select.tcu_brands option').removeAttr('selected');
            $('.finance select.tcu_brands option').each(function(){
                if($(this).attr('data-brand').toLowerCase() == $('body.page-template-financing-tco .tcu_page form.tcu_form .wrapper_lubinski_brands input:checked').val()){
                    $(this).attr('selected','selected');
                }
                else{ 
                    //$(this).prop("selected", false);
                    $(this).removeAttr('selected');
                }
            });
            updateModelsSelect();
            $('.wrapper_top_desktop').css('display','flex');

        });
    

        $('.page-template-financing-tco .tcu_page form.tcu_form select.tcu_select.tcu_brands').change(function(){
            updateModelsSelect();
            $('select.tcu_mm_models').attr('disabled',true);
        });
            $('.page-template-financing-tco .tcu_page form.tcu_form select.tcu_select.tcu_models').change(function(){
                $('select.tcu_mm_models + .ajax-loader').show();
                $('select.tcu_mm_models').attr('disabled',true);
                $('.select_wrapper.desktop > *').hide();
                $('.select_wrapper.desktop .mm_image2').css('display','inline-block');

                $('.calculator_result').hide();
                var brand =$('.finance select.tcu_brands option:selected').attr('data-brand');
                var model=$('.finance select.tcu_models option:selected' ).attr('data-id');
                dataLayer.push({
                    'Category': 'financing calculator', 
                    'action': 'choose model', 
                    'label': model, 
                    'event': 'auto_event'
                });
                //console.log('datalayer',dataLayer)
                        var url = '/wp-admin/admin-ajax.php';
                        if(window.location.href.indexOf('testonline') != -1){
                            url = 'wp-admin/admin-ajax.php';
                        }
                          $.ajax({
                          url: url, // AJAX handler
                          type: 'POST',
                          data:{
                              action:'get_market_models_in_financing_calc',
                              brand:  brand,
                              model: model,
                              apiurl: $('.codeoasis_api_link').html()
                          },
                          
                          success: function (res) {
                            res=JSON.parse(res);
                            $('.tcu_mm_models').empty();
                            if(res && res.model && res.model.market_models && res.model.market_models.length > 0){
                                $('.tcu_mm_models').append('<option selected disabled>בחר רמת גימור</option>');
                                res.model.market_models.forEach(element => {
                                    $('.tcu_mm_models').append('<option data-brand="'+brand+'" data-id="'+element.marketmodelcode+'" data-image="'+element.image.url+'" data-price="'+element.pricefrom +'" dir="ltr" value="'+element.marketmodelcode+'">'+element.marketmodelname+'</option>');
                                });
                                $('select.tcu_mm_models + .ajax-loader').hide();
                                $('select.tcu_mm_models').attr('disabled',false);
                            }
                            else{
                                $('.tcu_mm_models').append('<option value="-1" disabled>אין רמות גימור זמינות לדגם זה</option>');
                            }
                          }
                      });  
        
        
        });
        $('.page-template-financing-tco .tcu_page form.tcu_form select.tcu_select.tcu_mm_models').change(function(){
            $('.calculator_result .details').empty();
            dataLayer.push({
                'Category': 'financing calculator', 
                'action': 'choose sub model', 
                'label': $('.finance select.tcu_models option:selected' ).attr('data-id')+' | '+$(this).find('option:selected').html(), 
                'event': 'auto_event'
            });
            //console.log('datalayer',dataLayer)
                    if($(this).find('option:selected').attr('data-image')!='' &&
                    $(this).find('option:selected').attr('data-image')!= null &&
                    $(this).find('option:selected').attr('data-image') != 'undefined'){
                        $('.mm_image').attr('src',$(this).find('option:selected').attr('data-image'));
                    }
                    else $('.mm_image').attr('src','');
                    $('body.page-template-financing-tco .tcu_page .tcu_form .select_wrapper p.bolder').text($(this).find('option:selected').text());
                    $('body.page-template-financing-tco .tcu_page .tcu_form .select_wrapper h3 b').html('- <span>'+$(this).find('option:selected').attr('data-price').replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'</span> &#8362;');
                  
                    $('.select_wrapper.desktop > *').show();

                        if($('.mm_image').attr('src')=='' || $('.mm_image').attr('src')=='undefined' || $('.mm_image').attr('src')==null){
                            $('.mm_image').hide();
                            $('.mm_image2').show();
                        }
                        else{
                            $('.mm_image2').hide();
                            $('.mm_image').show();
                        }
                    // if($(window).width() > '776'){
                    //     $('.select_wrapper.desktop > *').show();
                    //     // $('body.page-template-financing-tco .tcu_page .tcu_form .select_wrapper p.bolder').show();
                    //     // $('body.page-template-financing-tco .tcu_page .tcu_form .select_wrapper h3').show();
                    // }
            buildCalculatorResult($(this).find('option:selected').attr('data-price'),$(this).find('option:selected').attr('data-image'), $(this).find('option:selected').text());
            $('.calculator_result').show();
            setTimeout(function(){
                $(".calculator_result .details .choose .switch input").click();
                $(".calculator_result .details .baloon").remove();
                $(".calculator_result .details .fieldsAndResult .fields .field:first-child").html('');
            },100)
            
            $('.result').css('height',$('.fields').height()-60);

            buildRanges($(this).find('option:selected').attr('data-price'));
            if($('.transbtn_div .fullbtn').length>0 && $('.transbtn_div .fullbtn').attr('href').indexOf('?car-model')<0){
                
                $('.transbtn_div .fullbtn').click(function(){
                    var rout = $('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .slider.round span:first-child').html();
                    if($('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .switch input').is(":checked")){
                        rout = $('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .slider.round span:last-child').html();
                    }
                    
                    dataLayer.push({
                        'Category': 'financing calculator', 
                        'action': 'order online', 
                        'label': $('.finance select.tcu_models option:selected' ).attr('data-id')+' | '+$('.finance select.tcu_mm_models option:selected').html()+' | '+rout, 
                        'event': 'auto_event'
                    });
                    //console.log('datalayer',dataLayer)
                })
                var url=$('.transbtn_div .fullbtn').attr('href');
                url+='?car-model='+$('.tcu_models').find('option:selected').attr('data-id');
                $('.transbtn_div .fullbtn').attr('href',url)
            }
            $('.transbtn_div *').css('display','inline-block');
            $('.under_btns_content').show();
financeCalc();

                
        
        
        });




    $('body.page-template-financing-tco .tcu_page form.tcu_form').on('click','.radio_wrapper input[type="radio"]', function() {
    
        updateLastMax($('.tcu_mm_models').find('option:selected').attr('data-price'));
        financeCalc();
        
    });
    $('.financeCalcForm .close').on('click',function(e){
        jQuery('.send_to_me').attr('aria-expanded','false');
        jQuery('.details_for_mail').show();
        jQuery('.finish').hide();
        jQuery('.details_for_mail .submit-btn span').remove();
        jQuery('.financeCalcFormBG').hide();
        setTimeout(function(){
            $('.financeFormWrapper form').trigger('reset');
            $('.financeFormWrapper form')[0].reset();
            $('.financeFormWrapper form').removeClass('invalid sent').addClass('init').attr('data-status','init');
            $('.financeFormWrapper form label').each(function(){
                if($(this).attr('for') != 'model' && $(this).attr('for') != 'market_model'){
                    $(this).removeClass('focus');
                }
            });
        },100);
        e.preventDefault();
    })
    $('.financeCalcForm .financeFormWrapper #contact_email').keydown(function(e) {
        if(/[a-zA-Z0-9@._-]/.test(e.key) === false){
            e.preventDefault();
            return;
        }
    });
    $('.financeCalcForm .financeFormWrapper ').on('click','input[type=submit]',function(e) {
        $('.financeFormWrapper .list-group-item input, .financeFormWrapper .list-group-item select').each(function(){
           if($(this)[0]==$('#contact_phone')[0]){
            
            var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
            if(re.test($(this).val())){
                $(this).parent().children('.wpcf7-not-valid-tip').removeClass('error');
                $(this).parent().children('.wpcf7-not-valid-tip').hide();
            }
            else{
                $(this).parent().children('.wpcf7-not-valid-tip').addClass('error');
                $(this).parent().children('.wpcf7-not-valid-tip').css('display','block');
            }
           }
           else if($(this)[0]==$('#contact_email')[0]){
            let is_email_required = $('input[name="is_email_required"]').val();
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 
            if(!$(this).val() && is_email_required == 'Yes'){
                $(this).parent().children('.wpcf7-not-valid-tip').addClass('error');
                $(this).parent().children('.wpcf7-not-valid-tip').css('display','block');
            }
            else if($(this).val()){
                if(re.test($(this).val())){
                    $(this).parent().children('.wpcf7-not-valid-tip').removeClass('error');
                    $(this).parent().children('.wpcf7-not-valid-tip').hide();
                }
                else{
                    $(this).parent().children('.wpcf7-not-valid-tip').addClass('error');
                    $(this).parent().children('.wpcf7-not-valid-tip').css('display','block');
                }
            }
           }
            else if(!$(this).val()){
                $(this).parent().children('.wpcf7-not-valid-tip').addClass('error');
                $(this).parent().children('.wpcf7-not-valid-tip').css('display','block');
            }
            else {
                $(this).parent().children('.wpcf7-not-valid-tip').removeClass('error');
                $(this).parent().children('.wpcf7-not-valid-tip').hide();
            }
            // if(!$('.privacy-question input').is(':checked')){
            //     $('.list-group-item .privacy-question + .wpcf7-not-valid-tip').addClass('error');
            //     $('.list-group-item .privacy-question + .wpcf7-not-valid-tip').css('display','block');
            // }
            // else {
            //     $('.list-group-item .privacy-question + .wpcf7-not-valid-tip').removeClass('error');
            //     $('.list-group-item .privacy-question + .wpcf7-not-valid-tip').hide();
            // }
            if(!$('.spam-question input').is(':checked')){
                $('.list-group-item .spam-question + .wpcf7-not-valid-tip').addClass('error');
                $('.list-group-item .spam-question + .wpcf7-not-valid-tip').css('display','block');
            }
            else {
                $('.list-group-item .spam-question + .wpcf7-not-valid-tip').removeClass('error');
                $('.list-group-item .spam-question + .wpcf7-not-valid-tip').hide();
            }
        });
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation()
        if($('.wpcf7-not-valid-tip.error').length==0){
            $(this).attr('disabled','disabled');
            $(this).next('.ajax-loader').css('visibility','visible')
            var url = '/wp-admin/admin-ajax.php';
            if(window.location.href.indexOf('testonline') != -1){
                url = 'wp-admin/admin-ajax.php';
            }
            let searchParams = new URLSearchParams(window.location.search)
            var camp='';
            if(searchParams.has('rcamp')){
                camp=searchParams.get('rcamp')
            }
            else if(searchParams.has('campaign')){
                camp=searchParams.get('campaign')
            }
            if(!camp)
                camp=$('.form_campaign_code').text();

                var rout = $('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .slider.round span:first-child').html();
                if($('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .switch input').is(":checked")){
                    rout = $('body.page-template-financing-tco .tcu_page .calculator_result .details .choose .slider.round span:last-child').html();
                }
                dataLayer.push({
                    'Category': 'financing calculator', 
                    'action': 'send personal details for quote ', 
                    'label': $('#model').val()+' | '+$('#market_model').val()+ ' | '+rout, 
                    'event': 'auto_event'
                });
                //console.log('datalayer',dataLayer);
                $.ajax({
                url: url,
                type: 'POST',
                data:{
                    action:'lub_createlead2',
                    
                    model:$('#model').attr('data-crmcode'),
                    market_model:$('#market_model').val(),
                    first_name:$('#first_name').val(),
                    last_name:$('#last_name').val(),
                    contact_phone:$('#contact_phone').val(),
                    contact_email:$('#contact_email').val(),
                    companycode: ($('#tcu_brands').val().toUpperCase()=='MG')?6:1,
                    manufacture:$('#manufacture').val()?$('#manufacture').val():$('input[name=brandname]:checked').val(),
                    form_campaign_code:camp,
                    form_default_showroom:$('.form_default_showroom').text()?$('.form_default_showroom').text():$('.form_default_showroom'+'_'+$('input[name=brandname]:checked').val().toUpperCase()).text(),
                    spam_question:$('.spam-question input:checked').val(),
                    //privacyQuestion:$('.privacy-question input:checked').val(),
                    utmSource: $('input[name="utmSource"]').val(),
                    gclid: $('input[name="gclid"]').val(),
                    utmMedium: $('input[name="utmMedium"]').val(),
                    utmCampaign: $('input[name="utmCampaign"]').val(),
                    utmContent: $('input[name="utmContent"]').val(),
                    utmTerm: $('input[name="utmTerm"]').val(),
                    rcamp: $('input[name="rcamp"]').val(),
                    ref: $('input[name="ref"]').val(),
                    adid: $('input[name="adid"]').val(),
                    adsetid: $('input[name="adsetid"]').val(),
                    clickid: $('input[name="clickid"]').val(),
                    sitesourcename: $('input[name="sitesourcename"]').val(),
                    placement: $('input[name="placement"]').val(),
                    spamtext: $('input[name="spamtext"]').val(),
                    ga_client_id: $('input[name="ga_client_id"]').val(),
                    ga_session_id: $('input[name="ga_session_id"]').val(),

                    // apiurl: $('.codeoasis_api_link').html()
                },
                
                success: function (res) {
                    res=JSON.parse(res);
                    if(res.errorcode=='200' || res.errorcode=='201'){
                        $('.finish .success').show();
                        $('.finish .error').hide();
                    }
                    else{
                        $('.finish .success').hide();
                        $('.finish .error').show();
                    }
                    $('.financeCalcForm .financeFormWrapper input[type=submit]').removeAttr('disabled');
                    $('.financeCalcForm form ul.list-group.details .wrapper_submit .submit-btn .ajax-loader').removeAttr('style');
                    $('.financeFormWrapper').hide();
                    $('.finish').show();
                
                }
            });  
           
        }
    });
    $('.financeCalcForm .financeFormWrapper ').on('keydown','input[type=submit]',function(e) {
        if ((e.which === 9 && !e.shiftKey)) {
            e.preventDefault();
            $('.financeCalcForm .close').focus();

        }
    });
    $('.close').on('keydown', function (e) {
        if ((e.which === 9 && e.shiftKey)) {
            // e.preventDefault();
            $('.financeFormWrapper input[name=first_name]').focus();
        }
    });




});

    function updateModelsSelect(){
        $('.finance select.tcu_models + .ajax-loader').show();
        $('.finance select.tcu_models').attr('disabled',true);
        $('.calculator_result').hide();

        var brand =$('.finance select.tcu_brands option:selected').attr('data-brand');
        //console.log('brand',brand)
        var url = '/wp-admin/admin-ajax.php';
        if(window.location.href.indexOf('testonline') != -1){
            url = 'wp-admin/admin-ajax.php';
        }
            $.ajax({
            url: url,
            type: 'POST',
            data:{
                action:'get_models_in_financing_calc',
                brand:  brand,
                apiurl: $('.codeoasis_api_link').html()
            },
            
            success: function (res) {
            res=JSON.parse(res);

            $('.finance .tcu_models').empty();
            $('.finance .tcu_mm_models').empty();
            
            if(res && res.models && res.models.length > 0){
                $('.finance .tcu_models').append('<option selected disabled>בחר דגם</option>');
                res.models.forEach(element => {
                    $('.finance .tcu_models').append('<option data-brand="'+brand+'" data-id="'+element.code+'" data-iselectriccar="'+element.iselectriccar+'">'+element.label+'</option>');
                });
                $('.finance select.tcu_models + .ajax-loader').hide();
                $('.finance select.tcu_models').attr('disabled',false);
            }
            else{
                $('.finance .tcu_models').append('<option value="-1" disabled>אין דגמים זמינים למותג זה</option>');

            }
            }
        });  
    
    
    }
    function updateLastMax(price){
        var percents=50;
        
        if($('.radio_wrapper label input:checked').val()>36){
            percents=40;
        }

        // if($(window).width() > '776'){
        //     var price=$('body.page-template-financing-tco .tcu_page .wrapper_top_desktop .select_wrapper h3 b span').html();
        // }else {    
        //     var price=$('body.page-template-financing-tco .tcu_page .calculator_result .details h3 b span').html();
        // }

        var first=$('.first_payment input').val();
        first=parseFloat(first.replace(/,/g, ''));


        var l=price*percents/100;
        if(l>first)
            l=first;
        $('.last_max_current').html(l.toString());
        $('.slider-input.last_payment + .slider-container .pointer-label.low').html('מקסימום סכום בלון: '+Number($('.last_max_current').html()).toLocaleString());

        if(Number($('.slider-input.last_payment + .slider-container .pointer.high').attr('aria-valuenow')) > Number($('.last_max_current').html())){
            $('.tcu_page .slider-input.last_payment').jRange('setValue', $('.last_max_current').html());
            // $('.slider-input.last_payment + .slider-container .pointer-label.low').show();
        }

    
    }
        function financeCalc(){

            if(!$('.choose .switch input').is(":checked")){//מסלול בהטבה
                var funding_amount=$('.funding_amount input').val();
                funding_amount=Number(funding_amount.replace(/,/g, ''));
                // funding_amount=parseFloat(funding_amount.replace(/,/g, '')); //באקסל סכום הלואה

                var monthes=$('.radio_wrapper label input:checked').val();
                monthes=parseFloat(monthes.replace(/,/g, ''));

                var ribit_percent=$('.track_in_benefit_interest_rate').html();
                ribit_percent=ribit_percent/100; //באקסל אחוז ריבית

                var calc=PMT1(ribit_percent/12,monthes,funding_amount)*-1;
                calc=calc.toFixed(0);
                // console.log(PMT1(0.03/12,60,13000)*-1); //numeric example
                var hefresh=$('.tcu_mm_models').find('option:selected').attr('data-price')-funding_amount;
        }else{//מסלול רגיל 
        
            var first=$('.first_payment input').val();
            first=parseFloat(first.replace(/,/g, ''));

            var last=$('.last_payment input').val();
            last=parseFloat(last.replace(/,/g, ''));

            var monthes=$('.radio_wrapper label input:checked').val();
            monthes=parseFloat(monthes.replace(/,/g, ''));

            var ribit_percent=$('.regular_track_interest_rate').html();
            ribit_percent=ribit_percent/100; //באקסל אחוז ריבית

            // console.log(PMT1(0.03/12,60,(13000-64000))*-1); //numeric example
            var pay_for_month=PMT1(ribit_percent/12,monthes,(first-last))*-1;
            var ribit_for_month=last*ribit_percent/12;

            calc=(ribit_for_month+pay_for_month).toFixed(0);
            var hefresh=$('.tcu_mm_models').find('option:selected').attr('data-price')-first;
        }
        
        // console.log(calc);
         $('.result_number1 span').html(hefresh.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
         $('.result_number2 span').html(calc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    }
    function PMT1(ir, np, pv, fv, type) {
        /*
         * ir   - interest rate per month
         * np   - number of periods (months)
         * pv   - present value
         * fv   - future value
         * type - when the payments are due:
         *        0: end of the period, e.g. end of month (default)
         *        1: beginning of period
         */
        var pmt, pvif;
    
        fv || (fv = 0);
        type || (type = 0);
    
        if (ir === 0)
            return -(pv + fv)/np;
    
        pvif = Math.pow(1 + ir, np);
        pmt = - ir * (pv * pvif + fv) / (pvif - 1);
    
        if (type === 1)
            pmt /= (1 + ir);
    
        return pmt;
    }
    
function buildCalculatorResult(price ,img, mm_name){
var str='';
    //  str+='<div class="details">';
     if($(window).width() < '992'){
        if(img!= null && img!='' && img!= 'undefined'){
            str+=`<image class="mm_image" src="`+img+`" alt="" />`;
        }
        str+=`<p class="bolder">`+mm_name+`</p>
        <h3>מחיר מחירון <b>- <span>`+numberWithCommas(price)+`</span> &#8362;</b></h3>`;
    }
    // str+=`<div class="choose">
    //     <label class="switch">
    //         <input type="checkbox" class="show_diff" name="show_diff">
    //         <span class="slider round">
    //             <span>מסלול בהטבה</span>
    //             <span>מסלול רגיל</span>
    //         </span>
    //     </label>
    // </div>`;
    str+=`<div class="choose" style="display:none">
        <label class="switch">
            <input type="radio" class="show_diff" name="show_diff">
        </label>
    </div>`;

    var max_funding_amount=$('.max_funding_amount').html()?$('.max_funding_amount').html():$('.max_funding_amount'+'_'+$('input[name=brandname]:checked').val().toUpperCase()).html()
 str+= `<p class="regular">`+$('.regular_track').html()+`</p>
<p class="baloon">`+$('.track_in_benefit').html().replace('[max]',max_funding_amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString())+`</p>
<div class="fieldsAndResult">
<div class="fields">
    <div class="field">
        <h2 class="funding_amount"><input type="text" value="0" /> &#8362;</h2>
        <h4 class="tcu_title_center">מה גובה המימון שתרצה?</h4>`;
        str+=`<input type="hidden" name="funding_amount" class="slider-input funding_amount" value="0" />
    </div>
    <div class="field">
        <h2 class="first_payment"><input type="text" value="2000" /> &#8362;</h2>
        <h4 class="tcu_title_center">מה גובה המימון שתרצה?</h4>
        <input type="hidden" name="first_payment" class="slider-input first_payment" value="2000" />
    </div>
    <div class="field">

        <h4 class="tcu_title_center">לתקופה של</h4>
        <div class="radio_wrapper">
            <label for="month_12">
                <input type="radio" id="month_12" name="period" value="12" checked>
                <div class="front-end box">
                    <span>12<br />חודשים</span>
                    <div class="years">שנה</div>

                </div>
            </label>
            <label for="month_24"> 
                <input type="radio" id="month_24" name="period" value="24">
                <div class="front-end box">
                    <span>24<br />חודשים</span>
                    <div class="years">שנתיים</div>
                </div>
            </label>
            <label for="month_36"> 
                <input type="radio" id="month_36" name="period" value="36">
                <div class="front-end box">
                    <span>36<br />חודשים</span>
                    <div class="years">3 שנים</div>

                </div>
            </label>
            <label for="month_48"> 
                <input type="radio" id="month_48" name="period" value="48">
                <div class="front-end box">
                    <span>48<br />חודשים</span>
                    <div class="years">4 שנים</div>

                </div>
            </label>
            <label for="month_60"> 
                <input type="radio" id="month_60" name="period" value="60">
                <div class="front-end box">
                    <span>60<br />חודשים</span>
                    <div class="years">5 שנים</div>

                </div>
            </label>
        </div>
    </div>

 <div class="field">
        <h2 class="last_payment"><input type="text" value="0" /> &#8362;</h2>
        <h4 class="tcu_title_center">תשלום סוף תקופה</h4>
        <span class="last_max_current hidden">0</span>
        <input type="hidden" name="last_payment" class="slider-input last_payment" value="100" />
    </div>
</div> `;
if($(window).width() > '992'){
    str+=`
    <div class="result">
    <div class="resultContent">
        <p class="result_text">`+$('.after_calculate_h1_first_text').html()+` </p>
        <div class="result_number1"><span>2,000</span> &#8362;</div>
        <p class="result_text">`+$('.after_calculate_h1_second_text').html()+` </p>
        <div class="result_number2"><span>2,000</span> &#8362;</div>
    </div>
    </div>`;
 }
str+=`</div>
    
</div>`;
var str2=`1`;

if($(window).width() <'992' && $('.details + .result_text').length==0){
    str2=`
    <p class="result_text">`+$('.after_calculate_h1_first_text').html()+` </p>
    <div class="result_number1"><span>2,000</span> &#8362;</div>
    <p class="result_text">`+$('.after_calculate_h1_second_text').html()+` </p>
    <div class="result_number2"><span>2,000</span> &#8362;</div>`;

 } 
$('.calculator_result .details').append(str);
$(str2).insertAfter('.calculator_result .details');
   

}
function buildRanges(price){
    // var a='0 km';
    // var b=$('.max_funding_amount').html()+' km';
    var price_or_max_funding;
     var max_funding_amount=$('.max_funding_amount').html()?$('.max_funding_amount').html():$('.max_funding_amount'+'_'+$('input[name=brandname]:checked').val().toUpperCase()).html()

    if(Number(price)< Number(max_funding_amount))
    price_or_max_funding=price;
    else price_or_max_funding=max_funding_amount;
    $('body.page-template-financing-tco .slider-input.funding_amount').jRange({
        from: 0,
        to:price_or_max_funding,
        step: 1,
        scale: ['0 &#8362;',Number(price_or_max_funding).toLocaleString()+' &#8362;'],
        format: '%s',
        // width: width_financing_calc,
        showLabels: true,
        snap: false,
        onstatechange: function(value){onFundingAmountChange(value,price_or_max_funding);}
    });

    $('body.page-template-financing-tco .slider-input.first_payment').jRange({
        from: 20000,
        to: price,
        step: 1,
        scale: ['20,000 &#8362;',Number(price).toLocaleString()+' &#8362;'],
        format: '%s',
        // width: width_financing_calc,
        showLabels: true,
        snap: false,
        onstatechange: function(value){onFirstPaymentChange(value,price);}
    });
    
    $('body.page-template-financing-tco .slider-input.last_payment').jRange({
        from: 0,
        to:price/2,
        step: 1,
        scale: ['0 &#8362;',(price/2).toLocaleString()+' &#8362;'],
        format: '%s',
        // width: width_financing_calc,
        showLabels: true,
        snap: false,
        onstatechange:function(value){ onLastPaymentChange(value,price/2);}
    });
    
    
    
    
    setTimeout(function(){

        $('.tcu_page.finance .slider-input.funding_amount + .slider-container .pointer.high').attr({
            'tabindex':'0',
            'role':'slider',
            'aria-valuemin':0,
            'aria-valuemax':max_funding_amount,
            'aria-valuenow':parseInt($('.tcu_page .slider-input.funding_amount').val()),
            'aria-describedby':'tcu_title',
            'aria-label':$('.tcu_page .pointer-label.high').html()
        });

        $('.tcu_page.finance .slider-input.first_payment + .slider-container .pointer.high').attr({
            'tabindex':'0',
            'role':'slider',
            'aria-valuemin':20000,
            'aria-valuemax':price,
            'aria-valuenow':parseInt($('.tcu_page .slider-input.first_payment').val()),
            'aria-describedby':'tcu_title',
            'aria-label':$('.tcu_page .pointer-label.high').html()
        });
    
    
        $('.tcu_page.finance .slider-input.last_payment + .slider-container .pointer.high').attr({
            'tabindex':'0',
            'role':'slider',
            'aria-valuemin':0,
            'aria-valuemax':price/2,
            'aria-valuenow':parseInt($('.tcu_page .slider-input.last_payment').val()),
            'aria-describedby':'tcu_title',
            'aria-label':$('.tcu_page .pointer-label.high').html()
        });
    
    
        //$('.tcu_page .slider-container .pointer-label.high ').attr('aria-live','polite');
        $('.finance.tcu_page .slider-input.funding_amount + .slider-container .pointer.high').on('keydown',function(event) {
            if((event.keyCode || event.which) == 38 || (event.keyCode || event.which) == 39){
                event.preventDefault();
                var currentVal = parseInt($('.tcu_page .slider-input.funding_amount').val());
                if(currentVal >= 0 && currentVal < max_funding_amount){
                    $('.tcu_page .slider-input.funding_amount').jRange('setValue', (currentVal + 1).toString());
                }
            }
            else if((event.keyCode || event.which) == 37 || (event.keyCode || event.which) == 40){
                event.preventDefault();
                var currentVal = parseInt($('.tcu_page .slider-input.funding_amount').val());
                if(currentVal > 0 && currentVal <= max_funding_amount){
                    $('.tcu_page .slider-input.funding_amount').jRange('setValue', (currentVal - 1).toString());
                }
            }
        });


        $('.finance.tcu_page .slider-input.first_payment + .slider-container .pointer.high').on('keydown',function(event) {
            //console.log((event.keyCode || event.which))
            if((event.keyCode || event.which) == 38 || (event.keyCode || event.which) == 39){
                event.preventDefault();
                var currentVal = parseInt($('.tcu_page .slider-input.first_payment').val());
                if(currentVal >= 20000 && currentVal < price){
                    $('.tcu_page .slider-input.first_payment').jRange('setValue', (currentVal + 1).toString());
                }
            }
            else if((event.keyCode || event.which) == 37 || (event.keyCode || event.which) == 40){
                event.preventDefault();
                var currentVal = parseInt($('.tcu_page .slider-input.first_payment').val());
                if(currentVal > 20000 && currentVal <= price){
                    $('.tcu_page .slider-input.first_payment').jRange('setValue', (currentVal - 1).toString());
                }
            }
        });
    
    
        $('.tcu_page.finance .slider-input.last_payment + .slider-container .pointer.high').on('keydown',function(event) {
            //console.log((event.keyCode || event.which))
            if((event.keyCode || event.which) == 38 || (event.keyCode || event.which) == 39){
                event.preventDefault();
                var currentVal = parseInt($('.tcu_page .slider-input.last_payment').val());
                
                
                // console.log('currentVal',currentVal);
                // console.log('max current',$('.last_max_current').html());
                if(currentVal >= 0 && currentVal <= Number($('.last_max_current').html()) && currentVal < price/2){
                    $('.tcu_page .slider-input.last_payment').jRange('setValue', (currentVal + 1).toString());
                }
            }
            else if((event.keyCode || event.which) == 37 || (event.keyCode || event.which) == 40){
                event.preventDefault();
                var currentVal = parseInt($('.tcu_page .slider-input.last_payment').val());
                if(currentVal > 0 && currentVal <= Number($('.last_max_current').html()) && currentVal <= price/2){
                    $('.tcu_page .slider-input.last_payment').jRange('setValue', (currentVal - 1).toString());
                }
            }
        });
    
    
        },500);
    
}


function onFundingAmountChange(value,max){
    var min=0;
    // var max=Number($('.max_funding_amount').html());
    value=Number(value);
    if(value<min)
    value=min;
    if(value == min){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('inside last').addClass('first');
        }
        else if(value > min && value < max){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('first last').addClass('inside');
        }
        else if(value == max){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('first inside').addClass('last');
        }
        else if(value > max){
            value = max;
        }
        $('.tcu_page .slider-input.funding_amount + .slider-container .pointer.high').attr({
            'aria-label':$('.tcu_page .pointer-label.high').html(),
            'aria-valuenow':parseInt($('.tcu_page .slider-input.funding_amount').val()),
            'aria-valuemin':min,
            'aria-valuemax':max,
        });
    $('.tcu_page .slider-input.funding_amount').jRange('setValue', value);
    $('h2.funding_amount').html('<input type="text" value="'+value.toLocaleString() + '" style="width:'+(value.toString().length+1)+'ch" /> &#8362;');
    financeCalc();
}

function onFirstPaymentChange(value,max){
       var min=20000;

      if(value=='NaN'){
        value=min;
      }
       value=Number(value);
       max=Number(max);
        if(value<min ){
            value=min;
        }
        if(value == min){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('inside last').addClass('first');
        }
        else if(value > min && value < max){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('first last').addClass('inside');
        }
        else if(value == max){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('first inside').addClass('last');
        }
        $('.tcu_page .slider-input.first_payment + .slider-container .pointer.high').attr({
            'aria-label':$('.tcu_page .pointer-label.high').html(),
            'aria-valuenow':parseInt($('.tcu_page .slider-input.first_payment').val()),
            'aria-valuemin':min,
            'aria-valuemax':max,
        });
        $('h2.first_payment').html('<input type="text" value="'+value.toLocaleString() + '" style="width:'+(value.toString().length+1)+'ch" /> &#8362;');
        updateLastMax($('.tcu_mm_models').find('option:selected').attr('data-price'));
        financeCalc();
}


function onLastPaymentChange(value,max){

    var min=0;
    value=Number(value);
    if(value<min)
    value=min;
        if(value == min){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('inside last').addClass('first');
        }
        else if(value > min && value < max){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('first last').addClass('inside');
        }
        else if(value == max){
            $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('first inside').addClass('last');
        }
        if(Number(value) >= Number($('.last_max_current').html())){
            $('.tcu_page .slider-input.last_payment').jRange('setValue', $('.last_max_current').html());
            $('.slider-input.last_payment + .slider-container .pointer-label.low').html('מקסימום סכום בלון: '+Number($('.last_max_current').html()).toLocaleString());            
            $('.slider-input.last_payment + .slider-container .pointer-label.low').show().delay(1000).fadeOut();
            value=Number($('.last_max_current').html());


        }
        $('.tcu_page .slider-input.last_payment + .slider-container .pointer.high').attr({
            'aria-label':$('.tcu_page .pointer-label.high').html(),
            'aria-valuenow':parseInt($('.tcu_page .slider-input.last_payment').val()),
            'aria-valuemin':min,
            'aria-valuemax':max,
        });
        // if(Number(value) > Number($('.last_max_current').html()))
            // $('.tcu_page .slider-input.last_payment').jRange('setValue', value);

        $('h2.last_payment').html('<input type="text" value="'+value.toLocaleString() + '" style="width:'+(value.toString().length+1)+'ch" /> &#8362;');
        financeCalc();

    
}
function numberWithCommas(x){
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
   
})(jQuery);


// WEBPACK FOOTER //
// assets/scripts/client/financScript.js